export interface IFolderBase {
    id: number;
    fullyQualifiedName: string;
    displayName: string;
}

export interface IFolder extends IFolderBase {
    level: number;
    description: string;
    fullyQualifiedName: string;
    parentId: number | null;
    type: FolderType;
    rolesAssignment: RolesAssignment;
    hasChildren: boolean;
    isSelectable: boolean;
    folderContext?: IFolderContext;
}

export interface IFolderContext {
    ancestors: number[];
    index: number;
    count: number;
    folders: IFolder[];
}

export interface IFolderAssignedUser {
    id: number;
    userName: string;
    isInherited: boolean;
}

export interface IFolderUserRole {
    id: number;
    name: string;
    origin: RoleOrigin;
    inheritedFromFolder?: IFolderBase;
}

export interface IFolderAssignment {
    id: number;
    user: IFolderAssignedUser;
    roles: IFolderUserRole[];
}

export enum FolderType {
    Classic = 'Classic',
    Modern = 'Modern',
}

export enum RolesAssignment {
    InheritFromTenant = 'InheritFromTenant',
    CustomRoles = 'CustomRoles',
}

export enum RoleOrigin {
    Inherited = 'Inherited',
    Assigned = 'Assigned',
}
